import dayjs from 'dayjs';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import MuiLink from '@mui/material/Link';
import { GridColDef } from '@mui/x-data-grid-pro';

import DataGridTable from '@/shared/components/dataDisplay/DataGridTable/DataGridTable';
import { AppPath } from '@/shared/constants/path';
import TableInstance from '@/shared/constants/tableInstance';
import Order from '@/shared/types/order/order.type';

import useOrdersTable_v2 from './hooks/useOrdersTable_v2';

const OrdersTable_v2: FC = () => {
  const navigate = useNavigate();

  const { apiRef, model, table, columns, visibilityModel, setVisibilityModel } =
    useOrdersTable_v2();

  const customizedColumns: GridColDef[] = columns.map((column) => {
    switch (column.field) {
      case 'in_order_id':
        return {
          ...column,
          renderCell(params) {
            const row = params.row as Order;
            return (
              <MuiLink
                component={Link}
                to={`${AppPath.Orders}/${row.in_order_id}`}
              >
                {row.in_order_id.split('-')[0]}
              </MuiLink>
            );
          },
        };
      case 'ts_created':
        return {
          ...column,
          renderCell: (params) => {
            const row = params.row as Order;
            return dayjs(row.ts_created).format('YYYY-MM-DD HH:mm A');
          },
        };
      default:
        return column;
    }
  });

  return (
    <div style={{ height: '80vh', width: '100%' }}>
      <DataGridTable
        getRowId={(item) => item.in_order_id as string}
        columns={customizedColumns}
        rows={table.data}
        rowCount={table.totalRows}
        loading={table.isLoading}
        columnVisibilityModel={visibilityModel}
        onColumnVisibilityModelChange={setVisibilityModel}
        checkboxSelection={false}
        customProps={{
          tableInstance: TableInstance.Orders,
          apiRef,
          model,
          toolbar: {
            toolbarActions: (
              <>
                <Button
                  variant='contained'
                  size='large'
                  onClick={() => navigate(`${AppPath.Orders}/create`)}
                >
                  Create Order
                </Button>
              </>
            ),
            rowActions: [
              {
                type: 'default',
                button: {
                  label: 'Edit',
                  onClick: (_, rowId) => {
                    navigate(`${AppPath.Orders}/${rowId}`);
                  },
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};

export default OrdersTable_v2;
